var module = angular.module('octopusApp.tenants');

module.directive('tenantTag', function () {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        require: 'ngModel',
        scope: true,
        link: function($scope, $element, attr, ngModel) {
            $scope.vm.isSwatch = (attr["mode"] === 'swatch');
            ngModel.$render = function onRender() {
                if (ngModel.$viewValue) {
                    $scope.vm.reloadTag(ngModel.$viewValue);
                }
            };
        },
        controller: function(octopusTagSets) {
            var vm = this;
            vm.tag = null;
            vm.reloadTag = reloadTag;

            function reloadTag(model) {
                if (typeof model === 'string'){
                    octopusTagSets.getTag(model).then(function (tag) {
                        vm.tag = tag;
                    });
                } else {
                    vm.tag = model;
                }
            }
        },
        controllerAs: 'vm',
        bindToController: true,
        template: '<span>' +
        '   <span ng-if="vm.tag">' +
            '   <i class="fa fa-square tag-swatch" ng-style="{\'color\': vm.tag.Color}" uib-tooltip="{{::vm.tag.Name}}" ng-if="::vm.isSwatch" tooltip-placement="auto top"></i>' +
            '   <span class="label label-info"   ng-style="{ \'background-color\': vm.tag.Color}"  ng-if="::!vm.isSwatch" uib-tooltip="{{::vm.tag.Description}}" tooltip-placement="auto top">' +
            '       {{vm.tag.Name}}' +
            '   </span>' +
        '   </span>' +
        '</span>'
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/directives/tenant_tag.js
// module id = 634
// module chunks = 1